import { IconButton, TooltipHost } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CommentMetaData = ({
  userInfo,
  commentNumber,
  timeOfCreation,
  onEditCommentClick,
  onDeleteCommentClick,
  disableEditComment,
  disableDeleteComment,
  onBehalfOf,
}) => {
  const { t: translator } = useTranslation();

  return (
    <>
      <div className="response-meta-data">
        <div className="response-comment-number">{commentNumber}</div>
        <div className="response-user-name">{userInfo}</div>
        <div className="response-date-time"> {timeOfCreation} </div>
        {!disableEditComment && (
          <div className="response-edit-button">
            <TooltipHost
              content={translator(
                'pages.hearingDetails.commentEditReplyTooltip',
              )}
              styles={tooltipHostStyle}
            >
              <IconButton
                iconProps={editCommentProps}
                onClick={onEditCommentClick}
                ariaLabel={'Edit comment'}
              />
            </TooltipHost>
          </div>
        )}
        {!disableDeleteComment && (
          <div className="response-delete-button">
            <TooltipHost
              content={translator(
                'pages.hearingDetails.commentDeleteReplyTooltip',
              )}
              styles={tooltipHostStyle}
            >
              <IconButton
                iconProps={deleteCommentProps}
                onClick={onDeleteCommentClick}
                ariaLabel={'Delete comment'}
              />
            </TooltipHost>
          </div>
        )}
      </div>
      {onBehalfOf ? (
        <div className="response-meta-data">
          {`${translator('pages.hearingDetails.onBehalfOf')}: ${onBehalfOf}`}
        </div>
      ) : null}
    </>
  );
};

export { CommentMetaData };

const tooltipHostStyle = {
  root: {
    display: 'inline-block',
  },
};
const editCommentProps = {
  iconName: 'EditNote',
};
const deleteCommentProps = {
  iconName: 'Delete',
};
